export const Button = ({ title, type = 'submit', disabled, className }) => {
    return (
        <button className={className} type={type} disabled={disabled}>{title}</button>
    );
};

